__turbopack_context__.v({
  "card": "AssetsSelectedCard-module__xdJRgW__card",
  "cardExpanded": "AssetsSelectedCard-module__xdJRgW__cardExpanded" + " " + "AssetsSelectedCard-module__xdJRgW__card",
  "header": "AssetsSelectedCard-module__xdJRgW__header",
  "headerLabel": "AssetsSelectedCard-module__xdJRgW__headerLabel",
  "headerStatic": "AssetsSelectedCard-module__xdJRgW__headerStatic",
  "info": "AssetsSelectedCard-module__xdJRgW__info",
  "list": "AssetsSelectedCard-module__xdJRgW__list",
  "name": "AssetsSelectedCard-module__xdJRgW__name",
  "row": "AssetsSelectedCard-module__xdJRgW__row",
  "title": "AssetsSelectedCard-module__xdJRgW__title",
});
